import { createContext, useContext, useState, useCallback, useEffect, useRef } from "react";
// import { AlertComp } from "../pages/FormularioPage/components/alert/alertComp";
import { useLocation } from "react-router-dom";

const AlertContext = createContext(null);

export function AlertProvider({ children }) {
  const [alertData, setAlertData] = useState({
    open: false,
    tipo: "info",
    titulo: "",
    msg: "",
    customIcon: null
  });

  const showAlert = useCallback((data) => {
    setAlertData({ open: true, ...data });
  }, []);

  const closeAlert = useCallback(() => {
    setAlertData((prev) => ({ ...prev, open: false }));
  }, []);

  // // Autocierre 10s
  // useEffect(() => {
  //   if (alertData.open && alertData.autoClose) {
  //     const timer = setTimeout(() => {
  //       closeAlert();
  //     }, 10000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [alertData.open, alertData.autoClose, closeAlert]);

  // // Cierre automático al cambiar de ruta
  // useEffect(() => {
  //   closeAlert();
  // }, [useLocation().pathname, closeAlert]);
  const currentLocation = useLocation();
    const previousPath = useRef(currentLocation.pathname);

    useEffect(() => {
      if (previousPath.current !== currentLocation.pathname) {
        closeAlert();
        previousPath.current = currentLocation.pathname;
      }
    }, [currentLocation.pathname, closeAlert]);

  return (
    <AlertContext.Provider value={{ showAlert, alertData, closeAlert }}>
      {children}
    </AlertContext.Provider>
  );
}

export function useAlert() {
  return useContext(AlertContext);
}